import { render } from "./GolfTour.vue?vue&type=template&id=fe7d8fc0&scoped=true"
import script from "./GolfTour.vue?vue&type=script&lang=js"
export * from "./GolfTour.vue?vue&type=script&lang=js"

import "./GolfTour.vue?vue&type=style&index=0&id=fe7d8fc0&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7d8fc0"]])

export default __exports__